import icon from 'assets/icons/martonticket-logo-white.png'
import simpleLink from 'assets/icons/simple_link.png'
import { useNavigate } from 'react-router-dom'

import { CenteredImage, ColumnWrapper, Logo, SimpleBox, Title } from '../footer.style'

export const Purchase = () => {
    const navigate = useNavigate()

    const handleRedirectToLanding = () => {
        navigate('/')
    }

    const handleRedirectToPdf = () => {
        window.open('https://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf', '_blank')
    }

    return (
        <ColumnWrapper>
            <Logo src={icon} alt="Logo" onClick={handleRedirectToLanding} />
            <Title>Szerezd be a következő élményed belépőjét!</Title>
            <SimpleBox>
                <CenteredImage src={simpleLink} alt="My image" onClick={handleRedirectToPdf} style={{ cursor: 'pointer' }} />
            </SimpleBox>
        </ColumnWrapper>
    )
}
